"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesFolderProperties = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var recompose_1 = require("recompose");
var moment = require("moment");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var sok_types_1 = require("@caddigital/sok-types");
require("./styles.scss");
var DatePicker_1 = require("components/DatePicker");
var formatSize_1 = require("utils/helpers/formatSize");
var updateProps = function (props) {
    if (props.filesFolderProperties.mode !== 'EDIT' &&
        props.filesFolderProperties.mode !== 'EDIT_SUBPROJECT') {
        return;
    }
    var values = Object.entries(props.filesFolderProperties.file.customMeta).reduce(function (acc, _a) {
        var key = _a[0], val = _a[1];
        if (val !== null && typeof val === 'object') {
            acc[key] = val.id;
        }
        else {
            acc[key] = val;
        }
        return acc;
    }, {});
    var nameMeta = props.metadata.find(function (m) { return m.identifier === 'name-meta'; });
    if (nameMeta !== undefined && nameMeta.id !== undefined) {
        values[nameMeta.id] = props.filesFolderProperties.file.name;
    }
    props.setValues(values);
    var metas;
    if (props.filesFolderProperties.mode === 'EDIT_SUBPROJECT') {
        metas = props.metadata.reduce(function (acc, x) {
            if (x.identifier !== 'subproject-status-meta' &&
                (x.bitField & sok_types_1.CustomMeta.SUBPROJECT) > 0) {
                x.name === (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name));
                acc.push(x);
            }
            return acc;
        }, []);
        metas.reverse();
    }
    else {
        metas = props.metadata.filter(function (x) { return (x.bitField & sok_types_1.CustomMeta.FILES_LIST) > 0; });
    }
    props.setFilteredMetas(metas);
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('values', 'setValues', {}), (0, recompose_1.withState)('filteredMetas', 'setFilteredMetas', []), (0, recompose_1.withState)('subprojectResponsibleGroup', 'setSubprojectResponsibleGroup', []), (0, recompose_1.withHandlers)({
    onChange: function (props) { return function (id) {
        return function (value) {
            var values = __assign({}, props.values);
            values[id] = value;
            props.setValues(values);
        };
    }; }
}), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        updateProps(this.props);
    },
    componentDidUpdate: function (prevProps) {
        if ((this.props.filesFolderProperties.mode === 'EDIT' ||
            this.props.filesFolderProperties.mode === 'EDIT_SUBPROJECT') &&
            prevProps.filesFolderProperties.mode !==
                this.props.filesFolderProperties.mode) {
            updateProps(this.props);
        }
        if ((this.props.filesFolderProperties.mode === 'EDIT_SUBPROJECT' &&
            prevProps.filesFolderProperties.mode !==
                this.props.filesFolderProperties.mode &&
            this.props.subproject) ||
            (this.props.filesFolderProperties.mode === 'EDIT_SUBPROJECT' &&
                prevProps.filesFolderProperties.mode === 'EDIT_SUBPROJECT' &&
                this.props.subproject &&
                prevProps.subproject &&
                this.props.subproject.groups !== prevProps.subproject.groups)) {
            var options = this.props.subproject.groups
                .filter(function (x) { return x.category.type !== 'CustomerCategoryUserGroup'; })
                .sort(function (a, b) { return a.category.name.localeCompare(b.category.name); })
                .map(function (x) {
                var groups = x.groups || [];
                return {
                    label: x.category.name,
                    options: groups.sort(function (a, b) { return a.name.localeCompare(b.name); })
                };
            });
            this.props.setSubprojectResponsibleGroup(options);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (((this.props.filesFolderProperties.mode === 'EDIT' ||
            this.props.filesFolderProperties.mode === 'EDIT_SUBPROJECT') &&
            nextProps.filesFolderProperties.mode !== 'EDIT' &&
            nextProps.filesFolderProperties.mode !== 'EDIT_SUBPROJECT') ||
            (this.props.filesFolderProperties.mode !== 'EDIT' &&
                this.props.filesFolderProperties.mode !== 'EDIT_SUBPROJECT' &&
                (nextProps.filesFolderProperties.mode === 'EDIT' ||
                    nextProps.filesFolderProperties.mode === 'EDIT_SUBPROJECT')) ||
            ((this.props.filesFolderProperties.mode === 'EDIT' ||
                this.props.filesFolderProperties.mode === 'EDIT_SUBPROJECT') &&
                (nextProps.filesFolderProperties.mode === 'EDIT' ||
                    nextProps.filesFolderProperties.mode === 'EDIT_SUBPROJECT'))) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var getError = function (props, key) {
    var errors = props.filesFolderProperties.validationErrors;
    if (errors && errors[key] && errors[key].length > 0) {
        return React.createElement("p", { className: 'form-error' }, errors[key][0]);
    }
    return undefined;
};
var getMetaLabel = function (item) {
    if ((item.bitField & sok_types_1.CustomMeta.SUBPROJECT) > 0) {
        return (0, translation_1.getLocalization)("subprojectMeta/".concat(item.name));
    }
    return item.name;
};
exports.FilesFolderProperties = enhance(function (props) {
    var filesFolderProperties = props.filesFolderProperties, values = props.values;
    var optionsIdx = props.filteredMetas.reduce(function (prev, c) {
        if (c.type === 'dependant-select' && c.options) {
            c.options.forEach(function (o) {
                if (values[c.id || ''] === o.value) {
                    prev[o.value] = values[c.id || ''];
                }
            });
        }
        return prev;
    }, {});
    return (React.createElement(sok_ui_1.Overlay, { isOpen: props.filesFolderProperties.mode.startsWith('EDIT') },
        React.createElement(sok_ui_1.SideMenu, { className: 'sok-files-folder-properties-overlay', isOpen: props.filesFolderProperties.mode.startsWith('EDIT'), docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: props.closeOverlay }, (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/header')),
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", { className: "content" },
                    React.createElement(sok_ui_1.RequestStatusBox, { status: props.filesFolderProperties.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILURE'] },
                        React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/saving')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/successSaving')),
                        React.createElement("span", null, props.filesFolderProperties.validationErrors
                            ? (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/validationError')
                            : (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/errorSaving'))),
                    React.createElement("div", { className: "body" }, props.filteredMetas.map(function (item, key) {
                        if (item.id === undefined)
                            return React.createElement("div", null);
                        if ((filesFolderProperties.mode !== 'EDIT' &&
                            filesFolderProperties.mode !== 'EDIT_SUBPROJECT') ||
                            !filesFolderProperties.file) {
                            return React.createElement("div", null);
                        }
                        var file = filesFolderProperties.file;
                        if (item.type === 'text') {
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement("div", { className: "".concat(item.identifier, "-row") },
                                        React.createElement(sok_ui_1.TextInput, { key: "custom-meta-input-".concat(item.identifier), id: "custom-meta-".concat(item.identifier), type: 'text', disabled: !item.editable, value: item.identifier === 'size-meta'
                                                ? typeof values[item.id] === 'number'
                                                    ? (0, formatSize_1.formatSize)(values[item.id])
                                                    : ''
                                                : values[item.id] || '', onChange: function (_a) {
                                                var value = _a.target.value;
                                                props.onChange(item.id)(value);
                                            } }),
                                        item.identifier === 'name-meta' &&
                                            (file.fileExtension || '').length > 0 && (React.createElement("span", null,
                                            ".",
                                            file.fileExtension))),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'textarea') {
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(sok_ui_1.TextInput, { key: "custom-meta-input-".concat(item.identifier), id: "custom-meta-".concat(item.identifier), placeholder: "", type: "textarea", rows: 5, disabled: !item.editable, value: values[item.id] || '', onChange: function (_a) {
                                            var value = _a.target.value;
                                            props.onChange(item.id)(value);
                                        } }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'reference') {
                            var meta_1 = values[item.id];
                            var options = [];
                            var selected = void 0;
                            if (item.identifier === 'subproject-responsible-person-meta' &&
                                props.subproject) {
                                options = props.subprojectResponsibleGroup;
                                var cat = meta_1 &&
                                    options.find(function (x) { return x.options.findIndex(function (z) { return z.id === meta_1; }) > -1; });
                                selected =
                                    (cat && cat.options.find(function (x) { return x.id === meta_1; })) ||
                                        undefined;
                            }
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(react_select_1.default, { classNamePrefix: 'react-select', placeholder: "".concat((0, translation_1.getLocalization)('global/select'), " ").concat(item.name.toLowerCase()), menuPlacement: 'auto', isDisabled: !item.editable, value: selected, options: options, getOptionLabel: function (opt) { return opt.name; }, getOptionValue: function (opt) { return opt.id; }, onChange: function (_a) {
                                            var id = _a.id;
                                            return props.onChange(item.id)(id);
                                        }, isClearable: false }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'select') {
                            var options = (item.options || [])
                                .sort(function (a, b) { return a.order - b.order; })
                                .map(function (v) { return ({ value: v.value, name: v.name }); });
                            var meta_2 = values[item.id];
                            var selected = (meta_2 &&
                                item.options &&
                                item.options.find(function (o) { return o.value === meta_2; })) ||
                                null;
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: "".concat((0, translation_1.getLocalization)('global/select'), " ").concat(item.name.toLowerCase()), menuPlacement: 'auto', isDisabled: !item.editable, value: selected, options: options, getOptionLabel: function (opt) { return opt.name; }, getOptionValue: function (opt) { return opt.value; }, onChange: function (_a) {
                                            var value = _a.value;
                                            return props.onChange(item.id)(value);
                                        }, isClearable: false }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'dependant-select') {
                            var options = (item.options || [])
                                .filter(function (x) {
                                return x.references === null ||
                                    (x.references && optionsIdx[x.references]);
                            })
                                .sort(function (a, b) { return a.order - b.order; })
                                .map(function (v) { return ({ value: v.value, name: v.name }); });
                            var meta_3 = values[item.id];
                            var selected = (meta_3 &&
                                options &&
                                options.find(function (o) { return o.value === meta_3; })) ||
                                null;
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: "".concat((0, translation_1.getLocalization)('global/select'), " ").concat(item.name.toLowerCase()), menuPlacement: 'auto', isDisabled: !item.editable, value: selected, options: options, getOptionLabel: function (opt) { return opt.name; }, getOptionValue: function (opt) { return opt.value; }, onChange: function (_a) {
                                            var value = _a.value;
                                            return props.onChange(item.id)(value);
                                        }, isClearable: false }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'checkbox') {
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(sok_ui_1.Input, { type: 'checkbox', label: item.name, value: values[item.id] || false, disabled: !item.editable, onChange: function (e) {
                                            return props.onChange(item.id)(!values[item.id]);
                                        } }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'number') {
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(sok_ui_1.TextInput, { key: "custom-meta-input-".concat(item.identifier), id: "custom-meta-".concat(item.identifier), type: "number", value: item.identifier === 'size-meta'
                                            ? (0, formatSize_1.formatSize)(values[item.id])
                                            : values[item.id], disabled: !item.editable, onChange: function (_a) {
                                            var value = _a.target.value;
                                            return props.onChange(item.id)(value);
                                        } }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'day') {
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(DatePicker_1.DatePicker, { selected: values[item.id] &&
                                            moment(values[item.id]), disabled: !item.editable, onChange: function (value) {
                                            return value &&
                                                props.onChange(item.id)(new Date(value).getTime());
                                        } }),
                                    getError(props, item.identifier))));
                        }
                        else if (item.type === 'datetime') {
                            return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    React.createElement("label", { key: "custom-meta-label-".concat(item.identifier), htmlFor: "custom-meta-".concat(item.identifier) }, getMetaLabel(item)),
                                    React.createElement(DatePicker_1.DatePicker, { timeCaption: (0, translation_1.getLocalization)('datePicker/time'), showTimeSelect: true, disabled: !item.editable, selected: typeof values[item.id] === 'number'
                                            ? moment(values[item.id])
                                            : null, timeIntervals: 15, dateFormat: "L HH:mm", onChange: function (value) {
                                            return value &&
                                                props.onChange(item.id)(new Date(value).getTime());
                                        } }),
                                    getError(props, item.identifier))));
                        }
                        return undefined;
                    })))),
            React.createElement(sok_ui_1.Footer, null,
                !props.hideSaveButton && (React.createElement(sok_ui_1.Button, { color: 'base-green', disabled: props.filesFolderProperties.status === 'SAVING', text: (0, translation_1.getLocalization)('userfront/order/addressbook/save'), onClick: function () {
                        if (props.filesFolderProperties.mode !== 'EDIT' &&
                            props.filesFolderProperties.mode !== 'EDIT_SUBPROJECT') {
                            return;
                        }
                        props.save(props.filesFolderProperties.file, props.metadata, props.values, props.filesFolderProperties.mode);
                    } })),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/close'), onClick: props.closeOverlay })))));
});
